function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Iterable, Map } from 'immutable';
import { Image, ViewportContext } from '@uncinc/uncinc-react-kitchen-sink';
import ContextualActionsButtons from "../ContextualActions/Buttons";
var ImageFromField = function ImageFromField(_ref) {
  var field = _ref.field,
    className = _ref.className,
    src = _ref.src,
    imageStyles = _ref.imageStyles,
    lazyload = _ref.lazyload,
    includeWebP = _ref.includeWebP;
  var viewportContext = useContext(ViewportContext);
  var getImageStyle = function getImageStyle(style) {
    var imageStyle = field.getIn(['styles', style]);
    if (!imageStyle) {
      console.error("The image style \"".concat(style, "\" is not available"), field.toJS());
    }
    return imageStyle;
  };
  var sources;
  if (Iterable.isIterable(imageStyles) && imageStyles.size > 0) {
    sources = imageStyles.map(function (style) {
      return getImageStyle(style);
    });
  } else if (typeof imageStyles === 'string') {
    sources = getImageStyle(imageStyles);
  } else if (typeof src === 'string') {
    sources = src;
  } else {
    var _Map;
    sources = Map((_Map = {}, _defineProperty(_Map, viewportContext.screenSizes.SCREEN_MOBILE, getImageStyle(viewportContext.imageStyles.SCREEN_MOBILE)), _defineProperty(_Map, viewportContext.screenSizes.SCREEN_TABLET, getImageStyle(viewportContext.imageStyles.SCREEN_TABLET)), _defineProperty(_Map, viewportContext.screenSizes.SCREEN_NORMAL, getImageStyle(viewportContext.imageStyles.SCREEN_NORMAL)), _defineProperty(_Map, viewportContext.screenSizes.SCREEN_WIDE, getImageStyle(viewportContext.imageStyles.SCREEN_WIDE)), _defineProperty(_Map, viewportContext.screenSizes.SCREEN_HUGE, getImageStyle(viewportContext.imageStyles.SCREEN_HUGE)), _Map));
  }
  return /*#__PURE__*/React.createElement(ContextualActionsButtons, {
    entityType: "media",
    entity: field
  }, /*#__PURE__*/React.createElement(Image, {
    src: sources,
    className: className,
    alt: field.get('alt'),
    title: field.get('title'),
    width: field.get('width'),
    height: field.get('height'),
    lazyload: lazyload,
    includeWebP: includeWebP
  }));
};
ImageFromField.propTypes = {
  imageStyles: PropTypes.oneOfType([PropTypes.string, ImmutablePropTypes.map]),
  src: PropTypes.string,
  field: ImmutablePropTypes.map,
  lazyload: PropTypes.bool,
  includeWebP: PropTypes.bool
};
ImageFromField.defaultProps = {
  imageStyles: Map(),
  src: null,
  field: Map(),
  lazyload: true,
  includeWebP: true
};
export default ImageFromField;